import { LoadingButton } from "@mui/lab";
import { Box, Button, Modal, Typography, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { usePagarCarritosMutation } from "../../redux/api/informeApi";
import { ICarrito } from "../../redux/models/typesInformes";
import { useAppSelector } from "../../redux/store";
import MyToastShow from "../Layout/MyToast";

type TModalPagarCarrito = {
    open: boolean
    onCancel: () => void
    carrito?: ICarrito
    onCarritoPagado: (carrito: ICarrito) => void
}
const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    boxShadow: 24,
    p: 4,
};


const ModalPagarCarrito = ({ carrito, open, onCancel, onCarritoPagado }: TModalPagarCarrito) => {
    const darkMode = useAppSelector(state => state.theme.darkTheme)

    const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
    const boxWidth = isMobile ? '100%' : '40rem'

    const [pagarCarrito] = usePagarCarritosMutation()
    const [loading, setLoading] = useState(false)


    const handlePagar = () => {
        setLoading(true)
        carrito && pagarCarrito([carrito.idCarrito]).unwrap()
            .then((r: any) => {
                MyToastShow({ message: 'Carpeta pagada o eliminado el pago exitosamente', type: 'success' })
                return onCarritoPagado({ ...carrito, pagado: !carrito.pagado})
            })
            .catch((err: any) => {
                MyToastShow({ message: 'Error al pagar o eliminar el pago de la carpeta', type: 'error' })
            })
            .finally(() => {
                setLoading(false)
                onCancel()
            })
    }

    return (
        <Modal
            open={open}
            onClose={onCancel}
            aria-labelledby={`pagar-carrito-${carrito?.idCarrito}`}
            sx={{
                width: '100%',
            }}
        >
            <Box sx={(theme) => ({
                ...style,
                width: boxWidth,
                overflow: 'auto',
                maxHeight: '100%',
                bgcolor: darkMode ? '#232323' : '#fff',

            })}
                aria-label={`pagar-container-${carrito?.idCarrito}`}
            >
                <Typography variant='h4'> Pagar Carrito</Typography>

                <Typography variant='h6'> ¿Está seguro que desea pagar/eliminar el pago del carrito {carrito?.idCarrito}? </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <LoadingButton loading={loading} variant='contained' color='error' onClick={() => handlePagar()}> Aceptar </LoadingButton>
                    <Button variant='contained' color='primary' sx={{ ml: 1 }} onClick={() => onCancel()}> Cerrar </Button>
                </Box>
            </Box>
        </Modal>

    );
}

export default ModalPagarCarrito;